import { Component } from '@angular/core';
import { getImgeUrl } from 'src/environments/environment';
import { CommonModule, NgFor } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdminService } from 'src/app/admin/admin.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginationComponent } from 'src/app/admin/pagination/pagination.component';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';

@Component({
  selector: 'app-biography-list',
  standalone: true,
  imports: [NgFor, RouterModule, ReactiveFormsModule, PaginationComponent, CommonModule],
  templateUrl: './biography-list.component.html',
  styleUrl: './biography-list.component.scss'
})
export class BiographyListComponent {
  biographies
  filter_form: FormGroup
  language = 1
  languages:any
  page = 1
  number_of_page = 1
  paginatedData: any[];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number;
  totalPages
  imageUrl = getImgeUrl()
  filter:any = {
    "full_name": '',
    "page": 1, 
    "lang": this.language
  }
  isToggled = false;

  category
  constructor(
    private adminService: AdminService,
    private formBuilder: FormBuilder,
    public themeService: ThemeCustomizerService, 
  ) {
    this.itemsPerPage = this.adminService.ITEM_PERPAGE
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });


  }

	

  toggleTheme() {
      this.themeService.toggleTheme();
  }


  ngOnInit(): void {

    this.createFilterForm()
    this.getLanguage()
    this.getList()
  }

  getLanguage() {
    this.languages = this.adminService.getWebsiteLanguages()
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.filter["page"] = page
    this.getList();
  }


  createFilterForm() {
    this.filter_form = this.formBuilder.group({
      full_name:["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
    })
  }

  applyFilter() {
    if(this.filter_form.invalid) return 
    const data = this.filter_form.value

    this.filter = {
      "full_name": data.full_name? data.full_name:'',
      "page": 1, 
      "lang": this.language
    }

    

    this.getList()

    

  }

  resetFilter() {
    this.filter_form.reset()
    this.filter.full_name = ''
    this.getList()
  }
  getList() {
    this.adminService.getRecordList(this.adminService.BIOGRAPHY_URL, this.filter).subscribe({
      next: (res) => {
        this.biographies = res["data"]
        this.totalItems = res["total_records"]
        console.log("page", this.number_of_page)

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }
}
